import { useTranslation } from 'react-i18next';
import { Bell, BellOff } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { etykietaDzwonka } from '@/lib/dzwonekAlertow';
import { cn } from '@/lib/utils';
import type { SavedSearchCadence } from '@/types/savedSearch';

/**
 * DZWONEK ALERTÓW obok pastylki „Moje filtry” w nagłówku panelu filtrów (Maciek 20.10): stan
 * alertów e-mail zbioru (`Bell` włączone, `BellOff` wyłączone) i skrót do bloku alertów w
 * Ustawieniach (`useOtworzUstawieniaAlertow`). Pokazywany tam, gdzie pastylka (najemca, nie w
 * edycji z profilu); o tym decyduje wołający przez `widoczny`. Wizualnie kółko 36 px jak pastylka
 * obok; na telefonie strefa dotyku 44 px (`after:-inset-1`), od `md` strefa = kółko.
 */
export function DzwonekAlertow({
  widoczny,
  alerty,
  naKlik,
}: {
  widoczny: boolean;
  /** `useMojeWyszukiwanie().data.alerts`; brak = jeszcze się wczytuje. */
  alerty: { enabled: boolean; cadence: SavedSearchCadence } | undefined;
  naKlik: () => void;
}) {
  const { t, i18n } = useTranslation();
  if (!widoczny || !alerty) return null;
  const etykieta = etykietaDzwonka(t, alerty, i18n.language);
  const Ikona = alerty.enabled ? Bell : BellOff;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={naKlik}
          data-testid="dzwonek-alertow"
          data-alerty={alerty.enabled ? 'wlaczone' : 'wylaczone'}
          aria-label={etykieta}
          className={cn(
            "relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors after:absolute after:-inset-1 after:content-[''] hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:after:inset-0",
            alerty.enabled ? 'border-primary text-primary' : 'border-border text-muted-foreground',
          )}
        >
          <Ikona className="h-[18px] w-[18px]" aria-hidden data-ikona={alerty.enabled ? 'bell' : 'bell-off'} />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end" data-testid="podpowiedz-dzwonka">{etykieta}</TooltipContent>
    </Tooltip>
  );
}

export default DzwonekAlertow;
